




























import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
@Component({
  components: {},
})
export default class CommissionList extends AbpBase {
  columns = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center',
    // },
    {
      title: '活动标题',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '开始时间',
      slot: 'startTime',
      align: 'center',
      // width: 140,
    },
    {
      title: '结束时间',
      slot: 'endTime',
      align: 'center',
      // width: 140,
    },
    {
      title: '订单金额',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '成交量',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '客单价',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '件单价',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '访问量',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '平均单价',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
    {
      title: '连带率',
      key: 'name',
      align: 'center',
      //  width: 100,
    },
  ]
  exporting: boolean = false
  copyData = [
    {
      image: '',
      name: '测试',
      status: '活动进行中',
      startTime: 'Tue, 25 Aug 2020 11:55:40 GMT',
      endTime: 'Tue, 25 Aug 2020 11:55:40 GMT',
    },
  ]
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      console.log(form)
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    let startTime = form['startTime'] ? this.dateString(form['startTime']) : null
    let endTime = form['endTime'] ? this.dateString(form['endTime']) : null
    // Api.statisCommissionList(
    //   startTime,
    //   endTime,
    //   this.pager.pageSize,
    //   this.pager.pageIndex
    // ).then((res) => {
    //   this.pager.total = res.data.totalCount
    //   // this.copyData = res.data.items
    // })
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData((this.$refs.lineForm as any).form)
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let startTime = form['startTime']
    let endTime = form['endTime']
    // Api.exportWidthdrawReportFile(
    //   this.pager.pageSize,
    //   this.pager.pageIndex,
    //   startTime,
    //   endTime
    // )
    //   .then((res) => {
    //     console.log(res);
    //     this.exporting = false
    //     this.download(res.data)
    //   })
    //   .catch((err) => {
    //     this.exporting = false
    //   })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '提佣统计表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
}
